import { render } from "./SleepStages.vue?vue&type=template&id=5c99dae0&scoped=true"
import script from "./SleepStages.vue?vue&type=script&lang=js"
export * from "./SleepStages.vue?vue&type=script&lang=js"

import "./SleepStages.vue?vue&type=style&index=0&id=5c99dae0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c99dae0"]])

export default __exports__